import React from "react";
import { DDNav } from "../DDNav/DDNav";

/**
 * Pantalla para cuando no se pudieron cargar los datos de un módulo DD.
 * Se muestra EN LUGAR del módulo: con los datos de demostración en pantalla,
 * el primer cambio (o el guardado automático) pisaría los datos reales de la empresa.
 */
export function DDLoadError({ className, onRetry, bare = false }) {
  return (
    <div className={className}>
      {!bare && <DDNav />}
      <div style={{ padding: "40px 22px", color: "#6B7280" }}>
        <p style={{ margin: "0 0 12px", color: "#991B1B", fontWeight: 600 }}>No se pudieron cargar los datos.</p>
        <p style={{ margin: "0 0 16px" }}>Revisá la conexión e intentá de nuevo. Tus datos guardados no se modificaron.</p>
        <button
          onClick={onRetry}
          style={{ padding: "8px 16px", borderRadius: 6, border: "1px solid #1D4E89", background: "#1D4E89", color: "#fff", fontWeight: 600, cursor: "pointer" }}
        >
          Reintentar
        </button>
      </div>
    </div>
  );
}
